var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../Base.js";
var Finalizable_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    construct(...args) {
      super.construct(...args);
      this.finalizer = null;
      this.finalizing = null;
      this.isFinalized = false;
      this.isFinalizing = false;
    }
    /**
     * This template method is called at the end of {@link #function-finalize}. By default it calls `destroy()`, but
     * can be replaced by the derived class. This can be useful if it is not the `Finalizable` instance that awaits
     * the {@link #function-finalize} method.
     */
    doFinalize() {
      this.destroy();
    }
    /**
     * This method is called (typically by this instance or its owner) to cleanup this instance while possibly first
     * waiting for the {@link #property-finalizer} promise to settle. Once settled, the {@link #function-doFinalize}
     * method is called.
     * @async
     */
    finalize() {
      const me = this;
      let ret = me.finalizing;
      if (!ret && !me.isFinalized) {
        me.isFinalizing = true;
        me.finalizing = ret = me._awaitFinalizer();
      }
      return ret;
    }
    async _awaitFinalizer() {
      const me = this;
      try {
        await me.finalizer;
      } finally {
        me.finalizing = null;
        me.isFinalized = true;
        me.doFinalize();
      }
    }
  }, __publicField(_a, "$name", "Finalizable"), _a;
};
export {
  Finalizable_default as default
};
